import { useState } from "react";
import { Input, Table, Space, DatePicker, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useRequest } from "ahooks";
import moment from "moment";
import { useAuthContext } from "@/components/auth/AuthProvider";
import { statistic as statisticService } from "@/services";
import AdministrativeTreeSelect from "@/components/common/AdministrativeTreeSelect";
import styles from "./index.module.less";

function ReceiveMessage() {
  const [code, setCode] = useState();
  const [keyword, setKeyword] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const auth = useAuthContext();

  const {
    data = [],
    loading,
    run,
  } = useRequest(
    (params, token) => {
      return statisticService.listMessageTotalDepartment(params, token);
    },
    {
      manual: true,
    }
  );

  const clickHandler = () => {
    run(
      {
        code,
        search: keyword,
        start_date: startDate,
        end_date: endDate,
      },
      auth.token
    );
  };

  const columns = [
    {
      title: "序号",
      key: "num",
      width: 50,
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: "上报单位",
      dataIndex: "name",
      width: 340,
    },
    {
      title: "上报总数",
      dataIndex: "total",
    },
    {
      title: "采用总数",
      dataIndex: "received",
    },
  ];

  return (
    <div className={styles.totalStatistic}>
      <div className="table-toolbar">
        <div className="left"></div>
        <div className="right">
          <Space>
            <div>
              单位类型：
              <AdministrativeTreeSelect
                token={auth?.token}
                value={code}
                onChange={setCode}
              />
            </div>
            <div>
              单位：
              <Input
                style={{ width: 160 }}
                placeholder="搜索单位"
                allowClear
                onChange={(e) => setKeyword(e.target.value)}
              />
            </div>
            <div>
              时间范围：
              <DatePicker.RangePicker
                onChange={([start, end]) => [
                  setStartDate(start.format("YYYY-MM-DD")),
                  setEndDate(end.format("YYYY-MM-DD")),
                ]}
              />
            </div>
            <div>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={clickHandler}
              />
            </div>
          </Space>
        </div>
      </div>
      <Table
        size="middle"
        columns={columns}
        dataSource={data}
        loading={loading}
      />
    </div>
  );
}

export default ReceiveMessage;
